export default "__VITE_ASSET__DBqoEmIG__"